import React from 'react';
import { SvgIcon } from '@mui/material';

const ExcelIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H8l2.5-3L8 11h4l2.5 3L12 17zm5-8H7V7h10v2z" />
  </SvgIcon>
);

export default ExcelIcon;
